import { createSlice } from '@reduxjs/toolkit';
import { logger } from 'shared/utils/logger';
import { OrdersStateType } from '../types/types';
import {
  getOrders,
  getOrderById,
  createOrder,
  updateOrder,
  deleteOrder,
  completeOrder,
} from '../actions/actions';

const initialState: OrdersStateType = {
  orders: [],
  orderDetail: {
    isLoading: false,
    data: null,
  },
  isLoading: false,
};

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    dropDetailData(state: OrdersStateType) {
      state.orders = [];
      state.orderDetail.data = null;
      state.orderDetail.isLoading = false;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    // getOrders
    builder
      .addCase(getOrders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOrders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.orders = action.payload;
      })
      .addCase(getOrders.rejected, (state) => {
        state.isLoading = false;
      });

    // getOrderById
    builder
      .addCase(getOrderById.pending, (state) => {
        state.orderDetail.isLoading = true;
      })
      .addCase(getOrderById.fulfilled, (state, action) => {
        state.orderDetail.isLoading = false;
        state.orderDetail.data = action.payload;
      })
      .addCase(getOrderById.rejected, (state) => {
        state.orderDetail.isLoading = false;
      });

    // createOrder
    builder
      .addCase(createOrder.fulfilled, (state, action) => {
        state.orders.push(action.payload);
      });

    // updateOrder
    builder
      .addCase(updateOrder.fulfilled, (state, action) => {
        const index = state.orders.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) {
          state.orders[index] = action.payload;
        }
        if (state.orderDetail.data?.id === action.payload.id) {
          state.orderDetail.data = action.payload;
        }
      });

    // deleteOrder
    builder
      .addCase(deleteOrder.fulfilled, (state, action) => {
        state.orders = state.orders.filter(
          (item) => item.id !== action.payload,
        );
        if (state.orderDetail.data?.id === action.payload) {
          state.orderDetail.data = null;
        }
      });

    // completeOrder
    builder
      .addCase(completeOrder.fulfilled, (state, action) => {
        const index = state.orders.findIndex(
          (item) => item.id === action.payload.id,
        );
        if (index !== -1) {
          state.orders[index] = action.payload;
        }
        if (state.orderDetail.data?.id === action.payload.id) {
          state.orderDetail.data = action.payload;
        }
      })
      .addCase(completeOrder.rejected, (state, action) => {
        logger.error('order/completeOrder rejected:', action.payload);
      });
  },
});

export const orderActions = orderSlice.actions;
export default orderSlice.reducer;
